export enum TravelTimeCreationEstimatorType {
  Fixed,
  RetrieveFromEdge,
}
